module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-04.e0a8e664.jpeg";